import axios from 'axios'
import {
	ElMessage
} from 'element-plus'
import store from '@/store'
import {
	getToken
} from '@/utils/cookies'

// 创建 axios 实例
const request = axios.create({
	baseURL: '/api', // 统一配置你的请求前缀
	timeout: 10000
})

// 请求拦截器
request.interceptors.request.use(
	config => {
		const token = store.getters['user/token'] || getToken()
		if (token) {
			config.headers.token = token
		}
		return config
	},
	error => {
		return Promise.reject(error)
	}
)

// 响应拦截器
request.interceptors.response.use(
	response => {
		const res = response.data

		// 如果后端自定义 code 不为 200，手动抛出错误信息
		if (res.code !== 200) {
			// 不在拦截器里弹出错误提示，交由页面自己处理
			return Promise.reject(new Error(res.msg || '服务器异常'))
		}

		return res
	},
	error => {
		// 网络错误或 HTTP 错误
		const msg =
			error.response?.data?.msg ||
			error.message ||
			'请求失败，请检查网络或联系管理员'

		// 弹出错误提示
		ElMessage.error(msg)

		return Promise.reject(new Error(msg))
	}
)

export default request